// TODO: temporary fix until we implement pagination https://github.com/influxdata/influxdb/pull/17336
// Different resources *might* have different limits
export const LIMIT = 100
export const BUCKET_LIMIT = 100
export const RULE_LIMIT = 100
export const DASHBOARD_LIMIT = 100
export const TASK_LIMIT = 500
